import { type ReactElement } from 'react';
import { MenuItem, TextField, Typography } from '@mui/material';
import type { TextFieldProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import { ChevronDown } from 'lucide-react';

export type PpSelect = TextFieldProps & {
  menuTitle?: string;
  options: Array<string>;
};

const StyledMenuTitle = styled(Typography)(({ theme }) => ({
  padding: theme.spacing(1, 2),
}));

export function Select({ menuTitle, options, placeholder, ...rest }: PpSelect): ReactElement {
  return (
    <TextField
      select
      {...rest}
      slotProps={{
        input: {
          sx: {
            '& .MuiOutlinedInput-notchedOutline span': {
              display: 'none', // prevents notch on input focus outline
            },
          },
        },
        select: {
          displayEmpty: true,
          IconComponent: ChevronDown,
          MenuProps: {
            MenuListProps: {
              disablePadding: true,
            },
            PaperProps: {
              sx: {
                border: (theme) => `1px solid ${theme.palette.grayscale[300]}`,
                marginTop: 0.5,
              },
            },
          },
          renderValue: (value): React.ReactNode => {
            if (!value) {
              return (
                <Typography color="text.light" variant="paragraphBodyM">
                  {placeholder}
                </Typography>
              );
            }

            // safe to cast as we know that the value is a string
            return value as string;
          },
        },
      }}
    >
      {menuTitle && <StyledMenuTitle variant="paragraphBodySBold">{menuTitle}</StyledMenuTitle>}
      {options.map((option) => (
        <MenuItem key={option} value={option}>
          {option}
        </MenuItem>
      ))}
    </TextField>
  );
}
